import { Col, Form, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import "./Fill_Form_Modal.css";
import Start_Btn from "../../common/start-btn/Start_Btn";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Alltypes, createcounsellingform } from "../../../redux/contain";
import { useEffect, useState } from "react";
import Success_Modal from "../../modals/success-modal/Success_Modal";

const Fill_Form_Modal = ({ show, handleClose }) => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const dispatch = useDispatch();
  const alltypes = useSelector((state) => state?.contain?.alltypes);

  useEffect(() => {
    dispatch(Alltypes(""));
  }, [dispatch]);

  const {
    register,
    control,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    // setErr("");
    try {
      const response = await dispatch(createcounsellingform(data));

      if (response?.payload?.success) {
        setShowModal(true);

        setTimeout(() => {
          setShowModal(false);
          handleClose();
        }, 5000);
      } else {
        setShowModal(true);
      }
    } catch (error) {
      // setShow(false);
      // setErr(true);
      console.error(error);
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   handleClose(); // close modal
  //   navigate("/"); // redirect homepage
  // };

  return (
    <Modal size="lg" show={show} onHide={handleClose} centered>
      <Modal.Body className="counselling_modal">
        <div className="modal_header">
          <h5 className="modal_title">
            Fill the form below to book your counselling session
          </h5>

          <div className="close_div">
            <img
              src="/assets/images/home_banner/close.png"
              alt="close-btn"
              className="close_btn"
              onClick={handleClose}
            />
          </div>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={6} sm={6}>
              {/* <Form.Group className="mb-3">
                <Form.Label>Full Name</Form.Label>
                <Form.Control type="text" />
              </Form.Group> */}
              <Form.Group className="mb-3">
                <Form.Label>Enter Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your Full Name"
                  {...register("name", { required: " Full Name is required" })}
                />
                {errors.name && (
                  <p
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontSize: "14px",
                    }}
                  >
                    {errors.name.message}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col md={6} sm={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel" // ✅ change from number → tel
                  placeholder="Enter your contact"
                  maxLength={10}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                  {...register("contact", {
                    required: "Contact is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Please enter a valid 10-digit contact",
                    },
                  })}
                />

                {errors.contact && (
                  <p
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontSize: "14px",
                    }}
                  >
                    {errors.contact.message}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} sm={6}>
              <Form.Group className="mb-3">
                {/* <Form.Label>Email address</Form.Label>
                <Form.Control type="email" /> */}
                <Form.Label>Enter Email</Form.Label>
                <Form.Control
                  //type="email"
                  type="text"
                  placeholder="Enter your email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      // A common regex pattern for email validation
                      //value: /^[^\s@]+@[^\s@]+\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                      // value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                      // value: /^[A-Za-z0-9](?:[A-Za-z0-9.+]*[A-Za-z0-9])?@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                      value: /^[A-Za-z0-9](?:[A-Za-z0-9.+]*[A-Za-z0-9])?@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                      message: "Please enter a valid email address",
                    },
                  })}
                />
                {errors.email && (
                  <p
                    style={{
                      color: "red",
                      marginTop: "5px",
                      fontSize: "14px",
                    }}
                  >
                    {errors.email.message}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col md={6} sm={6}>
              <Form.Group className="mb-3">
                {/* <Form.Label>Type of Counselling</Form.Label>

                <Select
                  options={counsellingOptions}
                  placeholder="select"
                  className="react_select"
                  classNamePrefix="select"
                /> */}

                <Form.Label>Type of Counselling</Form.Label>
                {/* <Controller
                  name="typec_id"
                  control={control}
                  rules={{ required: "Type of Counselling is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={alltypes}
                      onInputChange={(val) => {
                        dispatch(Alltypes(val));
                      }}
                    />
                  )}
                /> */}
                <Controller
                  name="typec_id"
                  control={control}
                  rules={{ required: "Type of Counselling is required" }}
                  render={({ field }) => (
                    <Select
                      options={alltypes}
                      value={
                        alltypes?.find((opt) => opt?.value === field?.value) ||
                        null
                      }
                      onChange={(selected) => field?.onChange(selected?.value)} // <-- FIX
                    />
                  )}
                />
                {errors?.typec_id && (
                  <Form.Text className="text-danger">
                    {errors?.typec_id?.message}
                  </Form.Text>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-4">
            {/* <Form.Label>Your Message</Form.Label>
            <Form.Control as="textarea" rows={4} /> */}
            <Form.Label>Type Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={1}
              placeholder="Type your Message here"
              {...register("message", {
                required: "Message is required",
              })}
            />
            {errors.message && (
              <p
                style={{
                  color: "red",
                  marginTop: "5px",
                  fontSize: "14px",
                }}
              >
                {errors.message.message}
              </p>
            )}
          </Form.Group>

          <div className="start">
            <Start_Btn text="Book Now" type="submit" />
          </div>
        </Form>
      </Modal.Body>
      <Success_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
        message={"Successful"}
      />
    </Modal>
  );
};

export default Fill_Form_Modal;
